import { render, staticRenderFns } from "./AddDocument.vue?vue&type=template&id=17d71941&scoped=true"
import script from "./AddDocument.vue?vue&type=script&lang=js"
export * from "./AddDocument.vue?vue&type=script&lang=js"
import style0 from "./AddDocument.vue?vue&type=style&index=0&id=17d71941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d71941",
  null
  
)

export default component.exports